// removed by extract-text-webpack-plugin
module.exports = {"table":"Table_table--2mx4M","isScrollable":"Table_isScrollable--C0i0F","isProcessing":"Table_isProcessing--2iktJ","thead":"Table_thead--1fo-Z","tbody":"Table_tbody--q-nbj","cellGroup":"Table_cellGroup--1mMQK","spacer":"Table_spacer--24uF4","base":"Table_base--2fG3t"};


//////////////////
// WEBPACK FOOTER
// ../node_modules/react-wot-bootstrap/lib/components/Table/Table.css
// module id = 1840
// module chunks = 16